export const heroDetails = {
  name: 'Mario',
  resume: {
    label: 'Download Resume',
    url: '/Resume-Mario-Mendoza.pdf',
  },
  roles: [
    'Software Engineer',
    'Cloud Architect/Developer',
    'Full Stack Developer',
    'Java Developer',
    'Python Specialist',
  ],
};
